import { render, staticRenderFns } from "./FormWrapper.vue?vue&type=template&id=ecbe1bc6&scoped=true&"
import script from "./FormWrapper.vue?vue&type=script&lang=js&"
export * from "./FormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FormWrapper.vue?vue&type=style&index=0&id=ecbe1bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbe1bc6",
  null
  
)

export default component.exports